import React from 'react';

import useParams from 'legacy/common/hooks/useParams';
import Redirect from 'legacy/components/util/Redirect/Redirect';
import { useGetEvent } from 'legacy/events/hooks';
import { EventForHost } from 'legacy/events/types';

import DashboardSkeleton from '../components/DashboardSkeleton';
import EventDashboardContent from './EventDashboardContent';
import EventDashboardProvider from '../context';

const NewEventDashboard = () => {
  const params = useParams<{ slug: string; invite: string }>();
  const id = params.slug;

  const { data: event } = useGetEvent(id, {
    shareToken: params.invite
  }) as { data: EventForHost };

  if (!event) {
    return <DashboardSkeleton />;
  }

  // Make sure only organizers can access the page
  if (event._id && !event.isOrganizer) {
    return <Redirect to={`/events/${event._id}`} />;
  }

  return (
    <EventDashboardProvider event={event}>
      <EventDashboardContent />
    </EventDashboardProvider>
  );
};

export default NewEventDashboard;
